<main class="main">
  <section class="vam_login_section vh-100">
    <div class="container-fluid h-100">
      <div class="row align-items-center h-100">
        <div class="col-md-6 vam_login_car_container">
          <div class="vam_login_car_ani_container">
            <img src="/assets/images/Image-3@2x.png" class="vam_login_car">
          </div>
        </div>
  
        <div class="col-md-6">
          <div class="logo">
            <a href="index.php" class="vam_logo_link">
              <img src="/assets/images/logo2.svg" class="vam_logo">
            </a>
          </div>
          <form class="vam_login_input_form credential">
            <div class="form-group">
              <input type="text" 
                name="username" 
                placeholder="Username" 
                class="form-control 
                credential__input" 
                required>
            </div>
            <!-- <div class="form-group">
              <input type="password" 
                name="password" 
                placeholder="Password" 
                class="form-control 
                credential__input" 
                required>
            </div> -->
  
            <div class="vam_login_btn_container">
              <button type="button" class="btn btn__primary w-100">
                Reset password
              </button>
            </div>
  
            <div class="vam_login_information">
              <a routerLink="/" class="login-link"><ion-icon name="log-in-outline" class="ion-lg mr-1"></ion-icon> Sign in</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</main>
